module.exports = __webpack_public_path__ + "img/stickman-2.215c2fe4.svg";